// Navigation Bar SECTION
const navBar = {
  show: true,
};

// Main Body SECTION
const mainBody = {
  gradientColors: "#4484ce, #1ad7c0, #ff9b11, #9b59b6, #ff7f7f, #ecf0f1",
  firstName: "Lorenzo",
  middleName: "",
  lastName: "Pesina",
  message: " Software Developer with passion for web development and analytics. ",
  icons: [
    {
      image: "fa-github",
      url: "https://github.com/lpdabest1",
    },

    {
      image: "fa-linkedin",
      url: "https://www.linkedin.com/in/lorenzopesina/",
    },
    {
      image: "fa-codepen",
      url: "https://codepen.io/lorenzopesina/",
    },
  ],
};

// ABOUT SECTION
// If you want the About Section to show a profile picture you can fill the profilePictureLink either with:
//a) your Instagram username
//      i.e:profilePictureLink:"johnDoe123",
//b) a link to an hosted image
//      i.e:profilePictureLink:"www.picturesonline.com/johnDoeFancyAvatar.jpg",
//c) image in "editable-stuff" directory and use require("") to import here,
//      i.e: profilePictureLink: require("../editable-stuff/hashirshoaeb.png"),
//d) If you do not want any picture to be displayed, just leave it empty :)
//      i.e: profilePictureLink: "",
// For Resume either provide link to your resume or import from "editable-stuff" directory
//     i.e resume: require("../editable-stuff/resume.pdf"),
//         resume: "https://docs.google.com/document/d/13_PWdhThMr6roxb-UFiJj4YAFOj8e_bv3Vx9UHQdyBQ/edit?usp=sharing",

const about = {
  show: true,
  heading: "About Me",
  //imageLink: require("../editable-stuff/lorenzopesina.jpg"), //comment out if this imagelink is bad or not functional
  imageSize: 300,
  message:
    "My name is Lorenzo Pesina. I’m a graduate of 2020 from The University of Texas at Austin with a degree in Economics. It was through my studies of analytics that I discovered my passion. I'm most passionate about software development that helps improve the community, and my goal is to pursue this passion within the field of software development & analytics. While as an intern at Renzoe Box, I was able to work on the development build of the new Renzoe Boz 2.0 website, hosted on the shopify platform. While doing this, I contributed to making a makeup quiz for customers to seamlessly get the best recommendations of products that suits their needs. Furthermore, I also worked on creating a palette builder application that would help customers be able to create their own Renzoe Box (palette builder). Lastly, I contributed to the back-end of a new project that focuses on color matching makeup products to user's skintones. I had scraped data from cosmetic websites and formatted the data collected into a readable dataframe (which would then be saved as a csv). In addition, I carried out testing of the accuracy of our data, as well as doing the descriptive statistics on our results. The next step in my career is at LPL Financial, where I will be a(n) Infrastructure Middleware Engineer.",
  resume: "https://drive.google.com/file/d/1j8SenVQ6666hPiGIkhNAwhUokSVZk9Pf/view?usp=sharing",
};

// PROJECTS SECTION
// Setting up project lenght will automatically fetch your that number of recently updated projects, or you can set this field 0 to show none.
//      i.e: reposLength: 0,
// If you want to display specfic projects, add the repository names,
//      i.e ["repository-1", "repo-2"]
const repos = {
  show: true,
  heading: "Recent Projects & Coursework",
  gitHubUsername: "lpdabest1", //i.e."johnDoe12Gh"
  reposLength: null,
  specificRepos: ["NFL-Player-Search-App","NFL-Player-Ranking","NFL_Scraper_App","Webscrapers","lpdabest1.github.io", "website", "cs-303e", "responsive-web-design","mmreview"],
};

// Leadership SECTION
const leadership = {
  show: true,
  heading: "Live View(s)",
  message:
    "The slides to the right are visual representations of some of the projects I have done. These projects include self-independent work and my internship work/collaborations. Enjoy and checkout Renzoebox! If you would like to view the website live, click on the image for more!",
  images: [

    { 
      img: require("../assets/img/NFL_Ranking.PNG"), 
      label: "NFL Player Performance Metric", 
      url: "https://share.streamlit.io/lpdabest1/nfl-player-ranking/main/app.py",
      paragraph: "I created an application that compares players to each other based on a ranking system derived from a formula that I created." 
    },
    { 
      img: require("../editable-stuff/nfl_app_scraper_web.PNG"), 
      label: "NFL Web Scraper", 
      url: "https://nfl-web-scraper-app.herokuapp.com/",
      paragraph: "I created live web scraper that collects data that the user is interested for more about the NFL and it' players." 
    },
    { 
      img: require("../editable-stuff/RenzoeBox Website.PNG"), 
      label: "RenzoeBox", 
      url: "https://www.renzoebox.com/",
      paragraph: "I created a beauty quiz application that will help clients/customers decide to pruchase makeup that is best suited to their criteria. This is done by having the user take the quiz and the results of the quiz recommended products that meet certain criteria that the customer responded in the quiz with." 
    },
    { 
      img: require("../editable-stuff/IFIXIT Page.PNG"), 
      label: "IFIXIT", 
      url: "https://codepen.io/lorenzopesina/full/vYgbxQg",
      paragraph: "IFIXIT Product Landing Page" 
    },
    { 
      img: require("../editable-stuff/Tech Doc.PNG"), 
      label: "Technical Documentation: Python", 
      url: "https://codepen.io/lorenzopesina/full/poRGagY",
      paragraph: "Technical Doc explaining the basics of Python 3." 
    },
    {
      img: require("../editable-stuff/Web capture_mmreview.jpeg"),
      label: "Movie Review",
      url: "https://mmreview.stackblitz.io/",
      paragraph: "Movie Review",
    },


  ],
  imageSize: {
    width:"615",
    height:"450"
  }
};

// SKILLS SECTION
const skills = {
  show: true,
  heading: "Skills",
  hardSkills: [
    { name: "Python", value: 90 },
    { name: "SQL", value: 75 },
    { name: "Data Structures", value: 85 },
    { name: "JSON", value: null},
    { name: "Jupyter Notebooks", value: null},
    { name: "Python Libraries: Beautiful Soup, Numpy, Pandas, Requests, etc...", value: null},
    { name: "JavaScript", value: 90 },
    { name: "React", value: 65 },
    { name: "HTML/CSS", value: null },
    { name: "Shopify (liquid)", value: null },
    { name: "Streamlit", value: null },
   
  ],
  softSkills: [
    { name: "Goal-Oriented", value: 80 },
    { name: "Collaboration", value: 90 },
    { name: "Adaptability", value: 85 },
    { name: "Problem Solving", value: 75 },
    { name: "Organization", value: 70 },
    { name: "Creativity", value: 90 },
    { name: "Hardworking", value: 90 },
  ],
};

// GET IN TOUCH SECTION
const getInTouch = {
  //gradientColors: "#4484ce, #1ad7c0, #ff9b11, #9b59b6, #ff7f7f, #ecf0f1",
  show: true,
  heading: "Contact",
  message:
    "I'm currently looking for full-time Software/Front-End Engineering or Developer opportunities! If you know of any positions available, if you have any questions, or if you just want to say hi, please feel free to email me at",
  email: "lorenzo.pesina@utexas.edu",
};

//EXPERIENCE SECTION
const experiences = {
  show: true,
  heading: "Experience",
  data: [
    {
      role: 'Infrastructure Middleware Engineer',// Here Add Company Name
      companylogo: require('../assets/img/MemMap_LPL_Financial_Logo.png'),
      date: 'November 2021 – Present',
    },
    {
      role: 'Full Stack Engineer Intern',// Here Add Company Name
      companylogo: require('../assets/img/renzoebox.png'),
      date: 'May 2021 – August 2021',
    },
    {
      role: 'Information Technology Student Specialist',
      companylogo: require('../assets/img/utsystem.png'),
      date: 'June 2018 – November 2019',
    },
  ]
}

// Blog SECTION
// const blog = {
//   show: false,
// };

export { navBar, mainBody, about, repos, skills, leadership, getInTouch, experiences };
